/**
 * Global namespace for `.dropdown-menu`.
 */
const dropdownMenuClass = "dropdown-menu";
export default dropdownMenuClass;
